module.exports = __webpack_public_path__ + "img/begin.091d9ca8.png";